<add-recipient [open]="add_recipient">

    <div class="createContactForm">

        <div class="bg-white dark:bg-black" style="height:668px; width:898px;border-radius: 15px">
            <nav
                class="header bg-['#000'] dark:bg-transparent theme-border border-b px-5 py-4 flex items-center justify-between">
                <p class="!mb-0 text-lg font-semibold">Contacts</p>

                <!-- close -->
                <div class="closeIcon cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" (click)="closeModal()" width="1em" height="1em"
                        viewBox="0 0 20 20">
                        <path fill="currentColor"
                            d="M2.93 17.07A10 10 0 1 1 17.07 2.93A10 10 0 0 1 2.93 17.07m1.41-1.41A8 8 0 1 0 15.66 4.34A8 8 0 0 0 4.34 15.66m9.9-8.49L11.41 10l2.83 2.83l-1.41 1.41L10 11.41l-2.83 2.83l-1.41-1.41L8.59 10L5.76 7.17l1.41-1.41L10 8.59l2.83-2.83z" />
                    </svg>
                </div>
            </nav>
            <div class="p-[40px]">
                <div class="search_recipient">
                    <input [formControl]="searchControl" (ngModelChange)="getSearchParam($event)"
                        (ngModelChange)="searchParam" placeholder="Search for contacts" />


                </div>
                <div class="mt-5">
                    <p class=" text-[#5B5B5B] text-sm">Showing {{contact_list.length}}</p>
                    <data-table [maxHeight]="'400px'" [skeletonColumns]="5">
                        <table class="data-table">
                            <thead>
                                <tr>
                                    <th><input type="checkbox" [checked]="allSelectedContacts"
                                            (change)="toggleAllContacts($event)" />
                                    </th>
                                    <th>Full Name</th>
                                    <th>Email Address</th>
                                    <th>Phone Number</th>
                                    <th>Gender</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr ms *ngFor="let row of contact_list">
                                    <td>
                                        <input type="checkbox" [(ngModel)]="row.selected"
                                            (change)="checkSelectionContact()" />
                                    </td>
                                    <td>{{ row?.firstName }} {{ row?.lastName }}</td>
                                    <td>
                                        {{ row?.emailAddress }}
                                    </td>
                                    <td>{{ row?.primaryContactNumber }}</td>
                                    <td style="text-transform:capitalize;">{{ row?.gender?.toLowerCase() }}</td>
                                    <td>{{ row?.date_scheduled }}</td>
                                    <td>{{ row?.created_by }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </data-table>
                </div>
                <!-- <app-pagination></app-pagination> -->
            </div>
            <nav
                class="header bg-['#000'] dark:bg-transparent theme-border border-t px-5 py-4 flex justify-end items-center">
                <button (click)="closeModal()" class="bg-black text-white rounded-full"
                    style="width: 100px; height:40px; font-size:16px">Done</button>
            </nav>
        </div>
    </div>
</add-recipient>